import React, { useState } from 'react';
import ScorePage from './score';
import CommentsListPage from './comments';
const IOSIGlucoScoreListPage = (props) => {

    React.useEffect(() => {

    }, [])
    return (
        <div style={{ height: '100%', width: '100%', }}>
            <ScorePage/>
            <CommentsListPage/>
        </div>
    );

}

export default IOSIGlucoScoreListPage